import {
  CONTENT_TYPES,
  resolveGameContentType,
} from "./contentType";
import { formatAnalyticsCount } from "./analyticsDemoData";

export function getProjectCardKind(game) {
  return resolveGameContentType(game);
}

export function getProjectCardAnalyticsRows(game, analyticsPreview) {
  const kind = getProjectCardKind(game);
  const analytics = game?.analytics ?? {};

  if (kind === CONTENT_TYPES.trainer) {
    return [
      { label: "Запусков", value: formatAnalyticsCount(analyticsPreview.starts) },
      {
        label: "Уникальных",
        value: formatAnalyticsCount(analyticsPreview.uniquePlayers),
      },
      {
        label: "Ответов",
        value: formatAnalyticsCount(analytics.trainerAnswers ?? 0),
        accent: true,
      },
    ];
  }

  if (kind === CONTENT_TYPES.knowledge_base) {
    return [
      { label: "Запусков", value: formatAnalyticsCount(analyticsPreview.starts) },
      {
        label: "Уникальных",
        value: formatAnalyticsCount(analyticsPreview.uniquePlayers),
      },
      {
        label: "Обращений",
        value: formatAnalyticsCount(analyticsPreview.starts),
        accent: true,
      },
    ];
  }

  return [
    { label: "Запусков", value: formatAnalyticsCount(analyticsPreview.starts) },
    {
      label: "Завершений",
      value: formatAnalyticsCount(analyticsPreview.completions),
    },
    {
      label: "Конверсия",
      value: `${analyticsPreview.conversion}%`,
      accent: true,
    },
  ];
}

export function getProjectCardMetaRows(game) {
  const kind = getProjectCardKind(game);

  if (kind === CONTENT_TYPES.trainer) {
    const questionCount = Array.isArray(game?.trainerQuestions)
      ? game.trainerQuestions.length
      : 0;
    return [
      { label: "Вопросов", value: questionCount },
      {
        label: "Тема",
        value: game?.trainerTheme?.trim() || "—",
      },
    ];
  }

  if (kind === CONTENT_TYPES.knowledge_base) {
    const itemCount = Array.isArray(game?.kbItems) ? game.kbItems.length : 0;
    return [
      { label: "Материалов", value: itemCount },
      {
        label: "Тема",
        value: game?.kbTheme?.trim() || "—",
      },
    ];
  }

  const sceneCount =
    game?.nodes?.filter((node) => node.type === "group")?.length ?? 0;

  return [
    { label: "Сцен", value: sceneCount },
    { label: "Описание", value: game?.description ? "Есть" : "Нет" },
  ];
}

export function getProjectCardTone(kind) {
  if (kind === CONTENT_TYPES.trainer) return "trainer";
  if (kind === CONTENT_TYPES.knowledge_base) return "kb";
  return "scenario";
}
